import { api } from "../APIClient";
import { ACTION_TYPE } from "reducers/actionType";
import {
  hydrateRecommendations,
  hydrateEligibility,
} from "actions/hydrateActions";

const ENDPOINT_PATH = "/service/context";

export const getInput = (recommendations_hash, eligibility_hash) => {
  return (dispatch) => {
    dispatch({ type: ACTION_TYPE.INPUT.LOADING });
    dispatch({
      type: ACTION_TYPE.INPUT.HASH,
      data: {
        recommendations_input_hash: recommendations_hash,
        eligibility_input_hash: eligibility_hash,
      },
    });
    return api
      .get(ENDPOINT_PATH)
      .then((response) => {
        dispatch({
          type: ACTION_TYPE.INPUT.SUCCESS,
          payload: { input: response.data },
        });
      })
      .then(() => {
        if (recommendations_hash) {
          dispatch(hydrateRecommendations(recommendations_hash));
        }
      })
      .then(() => {
        if (eligibility_hash) {
          dispatch(hydrateEligibility(recommendations_hash, eligibility_hash));
        }
      })
      .catch((error) => {
        dispatch({
          type: ACTION_TYPE.INPUT.FAILURE,
          payload: error,
        });
      });
  };
};
